import { TableDataApi } from '../../api';
import { isAuthenticated } from '../../api-handle/authService';
import Context from './index';
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const TableProvider = (props) => {
    const [data, setData] = useState([]);

    useEffect(() => {
        if (!isAuthenticated()) return;
        axios.get(TableDataApi).then(res => setData(res.data));
    }, [setData]);

    return (
        <Context.Provider
            value={{
                ...props,
                data
            }}
        >
            {props.children}
        </Context.Provider>
    );
};

export default TableProvider;